var _circle, _circle2, _g, _g2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 23.707,
    height: 23.707,
    x: 11.575,
    y: 21.038
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#alert_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#alert_svg__b)",
    shapeRendering: "crispEdges",
    transform: "rotate(-15 23.429 31)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.429,
    cy: 31,
    r: 4.286,
    fill: "url(#alert_svg__c)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23.429,
    cy: 31,
    r: 4.286,
    fill: "url(#alert_svg__d)",
    style: {
      mixBlendMode: "screen"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.429,
    cy: 31,
    r: 3.929,
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 0.714
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#alert_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M20.188 7.817a2.857 2.857 0 0 0-5.52 1.48"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 44.468,
    height: 41.804,
    x: 0.383,
    y: 1.876
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#alert_svg__f)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#alert_svg__g)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert_svg__h)",
    fillOpacity: 0.5,
    d: "m8.209 32.103-.185-.69a2.143 2.143 0 0 1 1.515-2.625 2.143 2.143 0 0 0 1.515-2.624l-1.433-5.347c-1.506-5.62 1.83-11.398 7.45-12.904s11.398 1.83 12.904 7.45l1.386 5.174a2.32 2.32 0 0 0 2.844 1.642 2.32 2.32 0 0 1 2.843 1.641l.138.518a2.857 2.857 0 0 1-2.02 3.5l-23.458 6.285a2.857 2.857 0 0 1-3.5-2.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.714,
    d: "M17.164 8.258c5.43-1.455 11.011 1.768 12.466 7.198l1.386 5.174a2.68 2.68 0 0 0 3.281 1.894 1.965 1.965 0 0 1 2.406 1.39l.138.516a2.5 2.5 0 0 1-1.768 3.062l-23.457 6.286a2.5 2.5 0 0 1-3.062-1.768l-.185-.69a1.786 1.786 0 0 1 1.262-2.187 2.5 2.5 0 0 0 1.768-3.062l-1.433-5.346c-1.455-5.43 1.768-11.012 7.198-12.467Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 44.332,
    height: 27.665,
    x: 0.531,
    y: 16.28
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#alert_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#alert_svg__j)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert_svg__k)",
    fillOpacity: 0.2,
    d: "M8.209 32.103a3.214 3.214 0 0 1 2.273-3.937l22.768-6.1a3.214 3.214 0 1 1 1.664 6.209l-22.769 6.1a3.214 3.214 0 0 1-3.936-2.272"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert_svg__l)",
    d: "M8.209 32.103a3.214 3.214 0 0 1 2.273-3.937l22.768-6.1a3.214 3.214 0 1 1 1.664 6.209l-22.769 6.1a3.214 3.214 0 0 1-3.936-2.272",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 0.714,
    d: "m10.574 28.511 22.769-6.1a2.857 2.857 0 0 1 1.478 5.518L12.053 34.03a2.857 2.857 0 0 1-1.478-5.519Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 23.706,
    height: 23.706,
    x: 15.861,
    y: 0.325
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#alert_svg__m)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#alert_svg__n)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#alert_svg__o)",
    d: "M23.429 10.286a4.286 4.286 0 1 1 8.57 0 4.286 4.286 0 0 1-8.57 0"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.714,
    d: "M27.715 6.357a3.928 3.928 0 1 1-.002 7.857 3.928 3.928 0 0 1 .002-7.857Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "alert_svg__b",
    width: 23.707,
    height: 23.707,
    x: 11.575,
    y: 21.038,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4764",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alert_svg__e",
    width: 8.475,
    height: 6.455,
    x: 13.142,
    y: 4.984,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_4764"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4384_4764",
    result: "effect2_dropShadow_4384_4764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4384_4764",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alert_svg__g",
    width: 44.468,
    height: 41.804,
    x: 0.383,
    y: 1.876,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4764",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alert_svg__j",
    width: 44.332,
    height: 27.665,
    x: 0.531,
    y: 16.28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4764",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "alert_svg__n",
    width: 23.706,
    height: 23.706,
    x: 15.861,
    y: 0.325,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4764",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_svg__c",
    x1: 23.429,
    x2: 23.429,
    y1: 30.518,
    y2: 35.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_svg__h",
    x1: 19.683,
    x2: 23.437,
    y1: 16.972,
    y2: 30.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_svg__k",
    x1: 22.604,
    x2: 23.529,
    y1: 27.871,
    y2: 31.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_svg__o",
    x1: 27.982,
    x2: 27.982,
    y1: 6.126,
    y2: 20.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alert_svg__a",
    transform: "translate(-11.575 -21.038)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.429,
    cy: 31,
    r: 4.286,
    transform: "rotate(-15 23.429 31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alert_svg__f",
    transform: "translate(-.383 -1.876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.209 32.103-.185-.69a2.143 2.143 0 0 1 1.515-2.625 2.143 2.143 0 0 0 1.515-2.624l-1.433-5.347c-1.506-5.62 1.83-11.398 7.45-12.904s11.398 1.83 12.904 7.45l1.386 5.174a2.32 2.32 0 0 0 2.844 1.642 2.32 2.32 0 0 1 2.843 1.641l.138.518a2.857 2.857 0 0 1-2.02 3.5l-23.458 6.285a2.857 2.857 0 0 1-3.5-2.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alert_svg__i",
    transform: "translate(-.531 -16.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.209 32.103a3.214 3.214 0 0 1 2.273-3.937l22.768-6.1a3.214 3.214 0 1 1 1.664 6.209l-22.769 6.1a3.214 3.214 0 0 1-3.936-2.272"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alert_svg__m",
    transform: "translate(-15.861 -.325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.429 10.286a4.286 4.286 0 1 1 8.57 0 4.286 4.286 0 0 1-8.57 0"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "alert_svg__d",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alert_svg__p",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "alert_svg__l",
    width: 1.524,
    height: 7.111,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alert_svg__p",
    transform: "scale(.00149 .00694)"
  })))));
};
export default SvgAlert;